<template>
  <v-container fluid fill-height v-if="model">
    <v-layout>
      <v-flex>
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>
              <v-icon>mdi-clipboard-text</v-icon>Print Quote
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
              <v-btn text :to="'/orders/view/' + this.id">
                <v-icon>mdi-arrow-left</v-icon>Back
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <pdf-viewer
            url="orders/print"
            :params="{ id, type }"
            :filename="this.filename"
            style="width: 300%"
          ></pdf-viewer>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  <page-loading v-else />

</template>

<script>
import PdfViewer from "@components/PdfViewer.vue";
import PageLoading from '../../components/PageLoading.vue';
export default {
  components: {
    PdfViewer,
    PageLoading
  },
  data() {
    return {
      id: this.$route.params.id,
      type: this.$route.params.type,
      model: null
    };
  },
  computed: {
    filename: function() {
      return this.model && this.model.invoiceNumber
        ? "invoice_" +
            this.model.client.displayName.replace(/\s/g, "-").toLowerCase() +
            "_" +
            this.model.invoiceNumber +
            ".pdf"
        : "order_" +
            this.model.client.displayName.replace(/\s/g, "-").toLowerCase() +
            "_" +
            this.model.id +
            ".pdf";
    }
  },
  mounted: function() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.getOrder(this.id);
    } else {
      this.$route.push("/orders");
    }
  },
  methods: {
    getOrder(id) {
      this.$store
        .dispatch("orders/get", {
          id: id
        })
        .then(data => (this.model = data));
    }
  }
};
</script>

<style></style>
